export const DOCUSIGN_CHECKBOX_FIELD_TYPE = 'checkBox';
export const DOCUSIGN_TEXTBOX_FIELD_TYPE = 'textBox';
export const DOCUSIGN_INTIALS_FIELD_TYPE = 'intial';
export const DOCUSIGN_SIGNATURE_FIELD_TYPE = 'sign';
export const DATA_PATH_SEPERATOR = '___';
